import type {IssueAgentTask} from '@github-ui/agent-sessions/hooks/use-issue-agent-tasks'
import {getTaskTitle} from '@github-ui/agent-sessions/utils/task-helpers'
import {ActionList, ActionMenu} from '@primer/react'
import {useCallback} from 'react'
import styles from './TaskSwitcher.module.css'

type TaskSwitcherProps = {
  tasks: IssueAgentTask[]
  selectedTask: IssueAgentTask
  onSelectTask: (task: IssueAgentTask) => void
}

export function TaskSwitcher({tasks, selectedTask, onSelectTask}: TaskSwitcherProps) {
  const selectedTitle = getTaskTitle(selectedTask)

  const handleSelect = useCallback(
    (task: IssueAgentTask) => {
      if (task.id !== selectedTask.id) {
        onSelectTask(task)
      }
    },
    [selectedTask.id, onSelectTask],
  )

  if (tasks.length <= 1) {
    return <span className={styles.heading}>{selectedTitle}</span>
  }

  return (
    <div className={styles.heading}>
      <ActionMenu>
        <ActionMenu.Button variant="invisible" className={styles.taskSwitcherButton}>
          {selectedTitle}
        </ActionMenu.Button>
        <ActionMenu.Overlay width="medium">
          <ActionList selectionVariant="single">
            <ActionList.Group>
              <ActionList.GroupHeading>Agent sessions</ActionList.GroupHeading>
              {tasks.map(task => (
                <ActionList.Item
                  key={task.id}
                  selected={task.id === selectedTask.id}
                  onSelect={() => handleSelect(task)}
                >
                  {getTaskTitle(task)}
                </ActionList.Item>
              ))}
            </ActionList.Group>
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </div>
  )
}
